import { useRef, useState } from "react";
import { api, formatApiError } from "./api";

export const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((s || "").trim());

export function validateContact(form) {
  if ((form.name || "").trim().length < 2) return "Please enter your full name.";
  if (!isEmail(form.email)) return "Please enter a valid email address.";
  if (form.phone && !/^[0-9+()\-.\s]{7,30}$/.test(form.phone)) return "Please enter a valid phone number.";
  if (!form.privacy_consent) return "Please confirm that you have read the Privacy Notice.";
  return null;
}

export function validateLocation(form) {
  if (!form.region) return "Please select a location.";
  if (!resolveCity(form)) return "Please select or enter a city or community.";
  return null;
}

export function resolveCity(form) {
  if (form.region === "other" || form.city === "Other community") return (form.city_custom || "").trim();
  return form.city;
}

export function useSubmit() {
  const started = useRef(Date.now());
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [reference, setReference] = useState(null);

  const submit = async (path, body) => {
    setSubmitting(true);
    setError("");
    try {
      const elapsed = Date.now() - started.current;
      let payload = body;
      if (body instanceof FormData) {
        const json = JSON.parse(body.get("payload"));
        body.set("payload", JSON.stringify({ ...json, elapsed_ms: elapsed }));
      } else {
        payload = { ...body, elapsed_ms: elapsed };
      }
      const { data } = await api.post(path, payload);
      setReference(data.reference);
      return true;
    } catch (e) {
      setError(formatApiError(e));
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  const reset = () => {
    started.current = Date.now();
    setReference(null);
    setError("");
  };

  return { submit, submitting, error, setError, reference, reset };
}

export function buildPayload(form, omit = []) {
  const out = { ...form, city: resolveCity(form) };
  ["city_custom", ...omit].forEach((k) => delete out[k]);
  return out;
}
